import { useState } from "react";
import { apiFetch } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState(""); const [sent, setSent] = useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    await apiFetch("/api/auth/forgot", { method: "POST", body: JSON.stringify({ email }) });
    setSent(true);
  }
  return sent ? <p className="mx-auto mt-24 max-w-sm">If an account exists, a reset link is on the way.</p>
    : <form onSubmit={(e) => void submit(e)} className="mx-auto mt-24 max-w-sm space-y-3">
        <h1 className="text-2xl font-semibold">Forgot password</h1>
        <Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Button type="submit">Send reset link</Button>
      </form>;
}
